const translations = {
    minutes: 'Minutes'
};

export default translations;
